export default __webpack_public_path__ + "static/media/Box_2_Quests.b16ebb4e.png";